/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


export default class
{
  matches ()
  {
    return false;
  }


  equals (other)
  {
    return other !== null && other.constructor === this.constructor;
  }


};
